import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const PopoverTitle = declareString(
  "promptLibrary.WorkgroupPublisherTeachingPopoverTitle",
  {
    text: "Share prompts to your teams",
    comment: "Teaching Popover title to share a prompt to a workgroup.",
  }
);

export const PopoverMessage = declareStringWithPlaceholders(
  "promptLibrary.WorkgroupPublisherTeachingPopoverMessage",
  {
    text: ({ action }) =>
      `Help your team get better results using the prompts you find useful. Simply hover over a prompt and select ${action}.`,
    comment: "Teaching Popover message to share a prompt to a workgroup.",
    placeholders: {
      action: "Action to be displayed in bold is Share to team",
    },
  }
);

export const PopoverShareToTeam = declareString(
  "promptLibrary.WorkgroupPublisherTeachingPopoverShareToGroup",
  {
    text: "Share to team",
    comment:
      "Action to be displayed in bold in promptLibrary.WorkgroupPublisherTeachingPopoverMessage-resource instead of action-placeholder.",
  }
);

export const PopoverGotItButton = declareString(
  "promptLibrary.WorkgroupPublisherTeachingPopoverGotItButtonLabel",
  {
    text: "Got it",
    comment: "Action to dismiss the teaching popover.",
  }
);
